<template>
  <!-- Edit your profile -->
  <div class="box mb-5">
    <v-layout
      d-block
      d-md-flex
      row
      ma-0
      align-center
      justify-space-between
      class="box-header"
    >
      <v-flex xs12>
        <h2 class="box-header-item mb-3 mb-md-0">{{ $t("profile-box.title") }}</h2>
      </v-flex>
    </v-layout>

    <div class="box-content">
      <!-- check if modules is not empty -->
      <v-layout
        class="box-content-item mb-5"
        d-block
        d-md-flex
        row
        ma-0
        align-center
        justify-space-between
      >
        <ProfileCard></ProfileCard>
      </v-layout>

      <template v-if="settings">
        <v-divider></v-divider>
        <h2 class="my-2">{{ $t("profile-box.settings.title") }}</h2>

        <v-row wrap>
          <v-col cols="12" md="4">
            <LocalChanger></LocalChanger>
          </v-col>

          <!-- <v-col cols="12" md="6">
            <small>{{ $t("profile-box.settings.label-1") }}</small>
          </v-col> -->
        </v-row>
      </template>
    </div>
  </div><!-- Edit your profile -->
</template>

<script>
import ProfileCard from '@/components/profile/ProfileCard'
import LocalChanger from '@/components/app/LocalChanger'

export default {
  props: {
    settings: {
      type: Boolean,
      default: () => false
    }
  },

  components: {
    ProfileCard: ProfileCard,
    LocalChanger: LocalChanger
  }
}
</script>
